import { useDispatch } from '@medlinker/fundamental';
import { useEffect, useRef } from 'react';
// import { useLocation } from '@medlinker/fundamental';
// import sensors from 'sa-sdk-javascript';

function usePageView(title?: string) {
  // const location = useLocation();
  const dispatch = useDispatch();
  const titleRef = useRef(title || document.title);

  titleRef.current = title || document.title;

  // useEffect(() => {
  //   const handleLocationChange = (location: any) => {
  //     console.log('autoTrackSinglePage', location.pathname);
  //   };

  //   const unsubscribeFromHistory = history.listen(handleLocationChange);

  //   handleLocationChange(history.location);

  //   return unsubscribeFromHistory;
  // }, [history]);

  useEffect(() => {
    if (titleRef.current.indexOf('加载中') === -1) {
      dispatch.app.collectPU({ title: titleRef.current });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}

export default usePageView;
